// theme/index.ts
import { createTheme, Theme } from '@mui/material/styles';
import { TenantConfig, congruityTenant } from './tenantConfigs';

export const getMuiTheme = (tenant: TenantConfig = congruityTenant): Theme => {
  return createTheme({
    palette: {
      // Must be a single color, not a gradient
      primary: {
        main: tenant.primaryColor
      }
    },
    // You can also store the gradient in a custom field if desired:
    // (TypeScript will let you type-extend it, or just do inline)
  });
};

